import { Group, Paper, Pill, Stack } from '@mantine/core';
import { Link } from '@tanstack/react-router';

import { TitleCard } from '@/core/components';

import { Faculty } from './../../model/FacultyTypes';
import classes from './FacultyCard.module.css';

export interface FacultyCardProps {
  faculty: Faculty;
  to: string;
}

export function FacultyCard({ faculty, to }: FacultyCardProps) {
  const { name, domain } = faculty;

  return (
    <Paper
      className={classes.card}
      component={Link}
      to={to}
      p="lg"
      c="var(--mantine-color-text)"
    >
      <Stack gap="12px">
        <TitleCard title={name} />

        <Group>
          <Pill>{domain}</Pill>
        </Group>
      </Stack>
    </Paper>
  );
}
